import api from "./api";

export interface MeData {
  id: string;
  nome: string;
  email: string;
  perfil: string;
  ativo: boolean;
  criadoEm: string;
  clienteId: string | null;
  fotoUrl: string | null;
  tarefaAtualId?: string | null;
  tarefaAtualDesde?: string | null;
  tarefaAtual?: {
    id: string;
    titulo: string;
    projeto: { id: string; nome: string } | null;
  } | null;
  // Dados profissionais (PDF — Cadastro de colaborador)
  cargo?: string | null;
  telefone?: string | null;
  whatsapp?: string | null;
  dataNascimento?: string | null;
  fusoHorario?: string | null;
  entrouEmpresaEm?: string | null;
  custoHora?: number | null;
}

export interface TrabalhandoAgora {
  id: string;
  nome: string;
  email: string;
  fotoUrl: string | null;
  perfil: string;
  vinculo: string | null;
  ehAtendente?: boolean;
  tarefaAtualDesde: string | null;
  /** Tempo ÚTIL no foco atual (só horário comercial) — bate com o card/produtividade. */
  tempoUtilFocoMs: number;
  tarefaAtual: {
    id: string;
    titulo: string;
    prazo: string;
    prioridade: string;
    status: string;
    projeto: { id: string; nome: string; tipo: string; fotoUrl: string | null } | null;
  } | null;
}

export async function definirTarefaAtual(tarefaId: string | null) {
  const r = await api.patch("/me/tarefa-atual", { tarefaId });
  return r.data.data as { tarefaAtualId: string | null; tarefaAtualDesde: string | null; tarefaAtual: MeData["tarefaAtual"] };
}

export async function listarTrabalhandoAgora() {
  const r = await api.get("/me/agora");
  return r.data.data as TrabalhandoAgora[];
}

export interface HistoricoItem {
  usuario: { id: string; nome: string; fotoUrl: string | null };
  tarefa: { id: string; titulo: string; projeto: { id: string; nome: string } | null };
  sessoes: Array<{ id: string; inicio: string; fim: string | null; fechadaPor: string | null }>;
  totalBrutoMs: number;
  totalUtilMs: number;
}

export async function listarHistoricoSessoes(params: { inicio: string; fim: string; usuarioId?: string; projetoId?: string }) {
  const q = new URLSearchParams();
  q.append("inicio", params.inicio);
  q.append("fim", params.fim);
  if (params.usuarioId) q.append("usuarioId", params.usuarioId);
  if (params.projetoId) q.append("projetoId", params.projetoId);
  const r = await api.get(`/me/historico?${q}`);
  return r.data.data as HistoricoItem[];
}

export interface HorarioComercial {
  janelas: Array<{ inicio: string; fim: string }>;
  diasUteis: number[]; // 0..6
}

export async function getHorarioComercial() {
  const r = await api.get("/me/horario-comercial");
  return r.data.data as HorarioComercial;
}

export async function setHorarioComercial(cfg: HorarioComercial) {
  const r = await api.put("/me/horario-comercial", cfg);
  return r.data.data as HorarioComercial;
}

// Config de operação (visibilidade do funcionário + pausa automática) — gestor/admin.
export interface OperacaoConfig {
  visibilidadeFuncionario: "alocadas" | "envolvido" | "todas";
  autoPausarFimExpediente: boolean;
  autoPausarTtlHoras: number | null;
}
export async function getOperacaoConfig() {
  const r = await api.get("/me/operacao");
  return r.data.data as OperacaoConfig;
}
export async function setOperacaoConfig(cfg: OperacaoConfig) {
  const r = await api.put("/me/operacao", cfg);
  return r.data.data as OperacaoConfig;
}

export async function uploadFotoPerfil(file: File) {
  const fd = new FormData();
  fd.append("file", file, file.name);
  const r = await api.post("/me/foto", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return r.data.data as { url: string };
}

export async function removerFotoPerfil() {
  await api.delete("/me/foto");
}

export async function getMe() {
  const r = await api.get("/me");
  return r.data.data as MeData;
}

export async function atualizarMe(dados: {
  nome?: string;
  email?: string;
  senhaAtual?: string;
  novaSenha?: string;
  // Campos pessoais que o próprio usuário pode editar.
  telefone?: string | null;
  whatsapp?: string | null;
  dataNascimento?: string | null;
  fusoHorario?: string | null;
}) {
  const r = await api.patch("/me", dados);
  return r.data.data as MeData;
}
